import DynamicInput from "components/dynamic/DynamicInput";
import { ScopeType } from "types/globalTypes";
import { Field } from "components/dynamic/DynamicForm";
import { motion } from "framer-motion";

interface Props {
  title: string;
  description?: string;
  fields: Field[];
  scope: ScopeType;
  isViewMode?: boolean;
}

export default function DynamicSection({
  title,
  description,
  fields,
  scope,
  isViewMode = false,
}: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-6"
    >
      <div className="border-b border-gray-200 pb-4 dark:border-white/10">
        <h2 className="text-transparent text-2xl font-bold text-gray-700 dark:text-gray-400">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            {description}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        <DynamicInput fields={fields} role={scope} readOnly={isViewMode} />
      </div>
    </motion.div>
  );
}
